import axios, { type AxiosResponse } from '@fs/zion-axios'
import { USER_SERVICE as SERVICE } from '../../serviceNames'

// DOCS: https://www.familysearch.org/service/user/profile/
// https://fhconfluence.churchofjesuschrist.org/pages/viewpage.action?spaceKey=WWSupport&title=Project+-+User+Profile

const BASE = `${SERVICE}/profile`

export function updateProfile(cisId: string, profile: Record<string, unknown>): Promise<AxiosResponse> {
  return axios.put(`${BASE}/users/${cisId}`, profile)
}
